<div class="flex flex-col gap-4">
  <div class="flex flex-col justify-stretch mb-1">
    <span class="m-0 truncate">{{ userDetails()?.name }}</span>
    <span class="m-0 truncate text-xs">{{ userDetails()?.login }}</span>
  </div>
  <div class="flex items-start mb-1">
    <span class="basis-1/4">{{ 'profile.role' | translate }}</span>
    <div class="user-group">
      @for (role of userDetails()?.roles; track role) {
        <span>{{ 'enum.Role.' + role | translate }}</span>
      }
    </div>
  </div>
  <div class="flex items-start mb-1">
    <span class="basis-1/4">{{ 'profile.factory' | translate }}</span>
    <div class="user-group">
      @for (factory of userDetails()?.factories; track factory.id) {
        <span>{{ factory.nameCyr }}</span>
      }
    </div>
  </div>
  <div class="mb-1">
    <div class="flex items-center gap-2">
      <span class="basis-1/4">{{ 'profile.theme' | translate }}</span>
      <p-button type="button" class="layout-topbar-action" (click)="toggleDarkMode()" text rounded>
        <i
          [ngClass]="{
            pi: true,
            'pi-moon': isDarkMode(),
            'pi-sun': !isDarkMode(),
          }"></i>
      </p-button>
    </div>
  </div>
  @if (!isAd()) {
  <p-button
    icon="pi pi-key"
    severity="info"
    [text]="true"
    (onClick)="hideProfile()"
    [routerLink]="['/change-password']"
    [label]="'topbar.menu.changePassword' | translate"
    ></p-button>
  }
  <hr />
  <p-button
    icon="pi pi-sign-out"
    severity="danger"
    [text]="true"
    (click)="logout()"
    [label]="'topbar.menu.signOut' | translate"></p-button>
</div>
